import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { Datetime } from "src/library/components/Datetime";
import Grid from "src/library/components/Hedron";
import HtmlBody from "src/library/components/Notes/HtmlBody";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { ISupportTicketDocument } from "src/modules/support/api/support.api";
import ListFiles, { FileData } from "src/core/shared/components/files/ListFiles";
import { rgba } from "src/library/utils";

interface SupportTicketMessageProps {
  createdAt: Date;
  message: string;
  from: string;
  documents?: ISupportTicketDocument[];
  internal?: boolean;
}

const SupportTicketMessage: React.ReactFCWithChildren<SupportTicketMessageProps> = ({
  createdAt,
  message,
  from,
  internal,
  documents = []
}) => {
  return (
    <TicketMessage
      direction="vertical"
      className={internal ? "internal" : ""}
    >
      <TicketMessageTitle direction="horizontal">
        <div className="message-from">
          <Icon
            className="person-icon"
            $fillColor="midGrey"
            icon={Icons.PERSON}
            size={20}
          />

          <div className="from-internal">
            <Text
              fontSize="h4"
              weight="bold"
            >
              {from}
            </Text>

            {internal && (
              <Text className="internal-note">
                {" added a private internal note."}
              </Text>
            )}
          </div>
        </div>

        <Text>
          <Datetime
            date={createdAt}
            format="HH:mm ddd D MMM YYYY"
          />
        </Text>
      </TicketMessageTitle>

      <HtmlBody body={message} />

      {documents?.length !== 0 && (
        <ListFiles
          icon={Icons.DOWNLOAD}
          files={documents.map(doc => ({
            s3FileKey: doc.key,
            name: (doc.slug).split(/^([0-9]{2}-[0-9]{2}-[0-9]{4}:[0-9]{2}:[0-9]{2}:[0-9]{2}--)/)[ 2 ]
          }))}
          onFileClick={(file: FileData) => {
            if (file && window) {
              window.open(file.s3FileKey, "_blank");
              window.close();
            }
          }}
        />
      )}
    </TicketMessage>
  );
};

const TicketMessage = styled(Grid.Bounds)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGrey};
    border-radius: ${theme.borderRadius};
    margin: ${theme.spacing.padding.sm} 0;
    padding: ${theme.spacing.padding.sm};

    &.internal {
      background-color: ${rgba(theme.colors.warn, 0.5)};

      .internal-note {
        font-style: italic;
      }
    }

    div {
      p:first-child {
        padding-top: 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;

const TicketMessageTitle = styled(Grid.Bounds)`
  ${({ theme }) => css`
    justify-content: space-between;
    margin-bottom: ${theme.spacing.margins.md};

    .message-from {
      display: flex;
      align-items: center;
    
      .person-icon {
        margin-right: 5px;
        border: 1px solid ${theme.colors.midGrey};
        border-radius: 50%;
        padding: 1px;
      }
    }
  `}
`;

export default SupportTicketMessage;
